export default class SaveAbsenceRequest {
    public userId: string = "";
    public workOrderId?: string | null;
    public startDate: Date = new Date();
    public endDate: Date = new Date();
    public managerId: string = "";
}
